export var Namespace;
(function (Namespace) {
    Namespace["DESKTOP_SKIN"] = "PARADesktopSkin";
    Namespace["DESKTOP_SKIN_PLUGIN_SAMPLE"] = "SkinPluginSample";
    Namespace["DESKTOP_SKIN_PLUGIN_SIDEBAR"] = "SkinSideBar";
    Namespace["DESKTOP_SKIN_PLUGIN_MULTI_CAM"] = "SkinMultiCam";
    Namespace["DESKTOP_SKIN_PLUGIN_RELATED_VIDEOS"] = "SkinRelatedVideos";
    Namespace["DESKTOP_SKIN_PLUGIN_MULTI_STREAM"] = "SkinMultiStream";
    Namespace["TAG_PLUGIN_SAMPLE"] = "TagPluginSample";
})(Namespace || (Namespace = {}));
